<template>
  <section class="world-background">
    <cards-roulette
      :options="options"
      :type="'sells_amount_ranges'"
      :withImages="false"
      :numerated="false"
    />
  </section>
</template>

<script>
import SellsAmountRanges from '@/constants/sells_amount_ranges.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import enumeratesFormater from '@/mixins/enumeratesFormater.js'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'


export default {
  components: { CardsRoulette },
  mixins: [enumeratesFormater, OnBoardStepMixin],
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = this.tableDataToListFormat(SellsAmountRanges)
  }
}
</script>
